import React, { useContext, useEffect, useRef } from 'react';
import { Tooltip } from 'primereact/tooltip';
import AppMenuitem from './AppMenuitem';
import { LayoutContext } from './context/layoutcontext';
import { MenuProvider } from './context/menucontext';

const AppSubMenu = ({ model }) => {
    const { layoutState, setBreadcrumbs, isHorizontal } = useContext(LayoutContext);
    const tooltipRef = useRef(null);

    useEffect(() => {
        if (tooltipRef.current) {
            tooltipRef.current.hide();
            tooltipRef.current.updateTargetEvents();
        }
    }, [layoutState.overlaySubmenuActive]);

    // Regenerate breadcrumbs whenever the menu model changes. The menu is
    // role-based and can populate/refresh after mount (e.g. the company-only
    // "Leads Dashboard" item, the Leads submenu with "Create Lead"), so a
    // mount-only [] would freeze the breadcrumb list and leave those routes
    // without a topbar breadcrumb.
    useEffect(() => {
        generateBreadcrumbs(model);
    }, [model]);

    const generateBreadcrumbs = (model) => {
        let breadcrumbs = [];

        const getBreadcrumb = (item, labels = []) => {
            const { label, to, items } = item;

            label && labels.push(label);
            items &&
                items.forEach((_item) => {
                    getBreadcrumb(_item, labels.slice());
                });
            to && breadcrumbs.push({ labels, to });
        };

        (model || []).forEach((item) => {
            getBreadcrumb(item);
        });
        // Bail out when unchanged so an unstable `model` reference (a fresh array
        // every render) can't cause a set → re-render → set loop.
        setBreadcrumbs((prev) =>
            JSON.stringify(prev) === JSON.stringify(breadcrumbs) ? prev : breadcrumbs
        );
    };

    return (
        <MenuProvider>
            <ul className={`layout-menu ${isHorizontal() ? 'layout-menu-horizontal' : ''}`}>
                {model.map((item, i) => {
                    return !item.separator ? <AppMenuitem item={item} root={true} index={i} key={`menu-item-${i}-${item.label || 'item'}`} /> : (!isHorizontal() ? <li key={`separator-${i}`} className="menu-separator"></li> : null);
                })}
            </ul>
            {!isHorizontal() && <Tooltip ref={tooltipRef} target="li:not(.active-menuitem)>.tooltip-target" />}
        </MenuProvider>
    );
};

export default AppSubMenu;